import { NavLink, Outlet } from "react-router-dom";

export const SEVERITY_STYLES = {
  high: "bg-[#EB57571A] text-[#EB5757]",
  medium: "bg-[#F2C94C33] text-[#B7791F]",
  low: "bg-[#0000000D] text-[#4F4F4F]",
};

export const STATUS_LABELS = {
  open: "Open",
  in_review: "In review",
  dismissed: "Dismissed",
  escalated: "Escalated",
  resolved: "Resolved",
};

export const HOLD_LABELS = {
  held: "Payment held",
  released: "Released",
  rejected: "Rejected & refunded",
  failed: "Failed & refunded",
};

export const CHANNEL_LABELS = {
  deposit: "Deposit",
  bank_payout: "Bank withdrawal",
  p2p_transfer: "Wallet transfer",
  p2p_request: "Money request",
  airtime: "Airtime",
  data: "Data",
  bills: "Bills",
  giftcard_buy: "Gift card buy",
  giftcard_sell: "Gift card sale",
  crypto_buy: "Crypto buy",
  crypto_sell: "Crypto sale",
  crypto_send: "Crypto send",
  crypto_receive: "Crypto received",
  purchase: "Purchase",
  system_credit: "Refund / credit",
  fee: "Fee",
  other: "Other",
};

export const TIER_LABELS = { unverified: "No verified BVN", bvn_verified: "BVN verified" };

export const naira = (n) => `₦${Number(n || 0).toLocaleString()}`;

export const Pill = ({ className = "", children }) => (
  <span className={`${className} rounded-[3px] px-[8px] py-[2px] text-[12px] capitalize whitespace-nowrap`}>
    {children}
  </span>
);

export const SeverityBadge = ({ severity }) => <Pill className={SEVERITY_STYLES[severity]}>{severity}</Pill>;

export const timeAgo = (d) => {
  if (!d) return "—";
  const s = Math.round((Date.now() - new Date(d)) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const dueText = (d) => {
  if (!d) return null;
  const ms = new Date(d) - Date.now();
  const h = Math.abs(ms) / 3600000;
  const span = h < 1 ? `${Math.round(h * 60)}m` : `${Math.round(h)}h`;
  return ms < 0 ? { text: `Overdue by ${span}`, late: true } : { text: `Due in ${span}`, late: false };
};

const TABS = [
  ["", "Overview"],
  ["alerts", "Alerts"],
  ["cases", "Cases"],
  ["rules", "Rules"],
  ["settings", "Settings"],
  ["audit", "Audit log"],
];

/** Monitoring section frame with tab navigation. */
export const MonitoringLayout = () => (
  <div className="w-full h-full pt-5 px-5 pb-40 space-y-5 font-dmsans">
    <div>
      <div className="font-bold text-[22px] text-[#070E05]">Transaction monitoring</div>
      <div className="flex gap-1 mt-3 border-b border-[#E6E7E9]">
        {TABS.map(([to, label]) => (
          <NavLink
            key={to}
            end={to === ""}
            to={`/monitoring${to ? `/${to}` : ""}`}
            className={({ isActive }) =>
              `px-4 py-2 text-[14px] -mb-px border-b-2 ${
                isActive ? "border-dark font-bold text-[#070E05]" : "border-transparent text-[#00000080]"
              }`
            }
          >
            {label}
          </NavLink>
        ))}
      </div>
    </div>
    <Outlet />
  </div>
);
